export function kmToMiles(value: string | number): number {
  if (!value) {
    return null;
  }

  const km: number = typeof value === 'string' ? Number(value) : value;

  if (km === 0) return 0;

  return Math.round(km / 1.609344);
}
